import { colorsV2 } from '../../figma/colors-v2';
import { ResponsiveTypography } from '../../figma/Typography/v3/ResponsiveTypography';
import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';
import { DolPopover } from '../Popover/DolPopover';
import { IconSystemV2ArrowChevronDownArrowDown } from '@doltech/icons/SystemV2/IconSystemV2ArrowChevronDownArrowDown';
import { flexGap, scrollBarStylesGeneral } from '@doltech/utils/lib/css-style';
import { OptionSelectItem } from './OptionSelectItem';
import { shadows } from '../shadows';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

const Main = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  border-bottom: 1px dashed ${colorsV2.neutral60};

  margin: 0 8px;
  ${flexGap(4)};
  cursor: pointer;

  &:hover {
    .answer {
      color: ${colorsV2.neutralPrimary} !important;
    }
    background: ${colorsV2.blue10};
    border-radius: 6px 6px 0px 0px;
    border-bottom: 1px solid ${colorsV2.blue100};
  }

  &.actived-text {
    border-bottom: 1px dashed ${colorsV2.blue40};
    &:hover {
      background: ${colorsV2.blue10};
      border-radius: 6px 6px 0px 0px;
      border-bottom: 1px dashed ${colorsV2.blue100};
    }
  }
`;

const DropdownContent = styled.div`
  display: grid;
  min-width: 220px;
  max-height: 350px;
  padding: 8px;
  align-items: center;
  gap: 16px;

  border-radius: 12px;
  border: 1px solid ${colorsV2.neutral40};
  background: ${colorsV2.white100};

  box-shadow: ${shadows.neutralShadowToBot4};
  overflow: auto;
  ${scrollBarStylesGeneral()};

  ${fromScreen(768)} {
    max-height: 100%;
  }
`;

interface QuestionItemSelectDashedProps {
  text?: string;
  options?: any;
  userAnswer?: number;
  withAbc?: boolean;
  onSelect: (input) => void;
}

export const QuestionItemSelectDashed = (props: QuestionItemSelectDashedProps) => {
  const { text, options, userAnswer, withAbc, onSelect } = props;

  return (
    <DolPopover
      maxWidth="500px"
      className="action-more-tooltip"
      trigger="click"
      placement="bottom-start"
      overlayClassName="un-styled no-arrow custom-inner-content"
      content={({ setTooltipOpen }) => (
        <DropdownContent>
          <ResponsiveTypography.Paragraph variant="medium/14-20" color={colorsV2.neutralDim}>
            {options?.length} OPTIONS
          </ResponsiveTypography.Paragraph>

          {options?.map((singleOption, optionIndex) => {
            const { key, value: optionValue, text: optionText } = singleOption;
            const selected = key === userAnswer;
            return (
              <div
                key={key}
                onClick={() => {
                  onSelect?.({ selectOption: singleOption });
                  setTooltipOpen?.(false);
                }}
              >
                <OptionSelectItem
                  index={optionIndex}
                  text={optionValue || optionText}
                  selected={selected}
                  withAbc={withAbc}
                />
              </div>
            );
          })}
        </DropdownContent>
      )}
    >
      <Main className={cl({ 'actived-text': text })}>
        {text ? (
          <ResponsiveTypography.Paragraph variant="medium/14-20" color={colorsV2.blue100}>
            {text}
          </ResponsiveTypography.Paragraph>
        ) : (
          <ResponsiveTypography.Paragraph
            variant="medium/14-20"
            color={colorsV2.neutralSecondary}
            className="answer"
          >
            Select answer
          </ResponsiveTypography.Paragraph>
        )}
        <IconSystemV2ArrowChevronDownArrowDown size={16} color={colorsV2.neutral60} />
      </Main>
    </DolPopover>
  );
};
